import { Layout, Text, Spinner, FlexContainer, Banner } from '@taxdown/piccolo-web';
import { locizeNS } from 'Services/i18n';
import useTranslation from 'Hooks/useTranslation';
import { useSmartFilter } from 'Hooks/useSmartFilter';
import OneColLayout from 'Components/Layouts/OneColLayout';
import { PlansType } from 'Types/common';
import CardPlan from './components/CardPlan';
import { useFetchGetPlans } from './hooks';
import * as Styled from './styles';
import IncomeFilter from './components/IncomeFilter';
import Contact from './components/Contact';
import MobileSlider from './components/MobileSlider';

const Plans = (): JSX.Element => {
  const { data, isLoading } = useFetchGetPlans();
  const info = useSmartFilter({
    plans: data,
  });
  const { t } = useTranslation(locizeNS.PLANS);
  if (isLoading || !data || !info || !info.plan) {
    return (
      <OneColLayout>
        <Layout.Centered size="L">
          <Spinner size="L" justify="center" align="center" />
        </Layout.Centered>
      </OneColLayout>
    );
  }

  return (
    <OneColLayout>
      <Styled.MobileContainer>
        <Styled.LayoutCentered size="S">
          <Text
            type="headline"
            align="start"
            color="dark"
            size="M_L_S"
            mb="fds_size_16"
            mt="fds_size_40"
          >
            {t('Plans.header.title')}
          </Text>
          <Text type="paragraphs" align="start" color="dark" size="L_L_S" mb="fds_size_40">
            {t('Plans.subtitle')}
          </Text>
          <IncomeFilter
            stateFunctions={info.stateFunctions}
            isPayLater={info.plan.length !== 2}
            data={data}
          />
          <MobileSlider plans={info.plan} info={info} />
          {data.length === 2 && (
            <Banner
              buttonLabel=""
              hasIcon
              id="default"
              mode="pro"
              label={t('Plans.banner.title')}
              mt="fds_size_32"
            />
          )}
          <Contact />
        </Styled.LayoutCentered>
      </Styled.MobileContainer>
      <Styled.Container>
        <Layout.Centered size="L">
          <Text
            type="headline"
            align="start"
            color="dark"
            size="M_L_S"
            mb="fds_size_16"
            mt="fds_size_40"
          >
            {t('Plans.header.title')}
          </Text>
          <Text type="paragraphs" align="start" color="dark" size="L_L_S" mb="fds_size_40">
            {t('Plans.subtitle')}
          </Text>
          <IncomeFilter
            stateFunctions={info.stateFunctions}
            isPayLater={info.plan.length !== 2}
            data={data}
          />
          <FlexContainer gap="dimension_16" wrap="wrap">
            {info &&
              info?.plan?.map((item: PlansType) => (
                <CardPlan
                  plan={item}
                  key={item.id}
                  plansAmount={info?.plan?.length}
                  recommendPlan={info.plan}
                  planSelect={info.planRecommended}
                />
              ))}
          </FlexContainer>
          {data.length === 2 && (
            <Banner
              buttonLabel=""
              hasIcon
              id="default"
              mode="pro"
              label={t('Plans.banner.title')}
              mt="fds_size_32"
            />
          )}
          <Contact />
        </Layout.Centered>
      </Styled.Container>
    </OneColLayout>
  );
};

export default Plans;
